<app-table
  [service]="recurrenceService"
  pageFunctionName="getRecurrencesList"
  [cols]="cols"
  sortField="createdAt"
  [sortOrder]="-1"
  [defaultRows]="25"
  [dropdownFilters]="dropdownFilters"
  [addButton]="false"
  [changeColumns]="true"
  modelName="recorrências"
  tableTitle="Loja - Recorrências"
/>
